<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div class="filters-header">
    <div class="filters-row">
      <slot name="filters" />
      <slot name="sort">
        <PrimeSelect
          v-model="selectedSortFilterCopy"
          :options="sortableOptions"
          :placeholder="$t('sortOn')"
          option-label="name"
          show-clear
          size="small"
        />
        <PrimeButton
          v-if="isAscending && selectedSortFilter && selectedSortFilter.sort"
          icon="ri-sort-asc"
          :aria-label="$t('sortAscending')"
          text
          size="small"
          @click="changeSortOrder"
        />
        <PrimeButton
          v-else-if="
            !isAscending && selectedSortFilter && selectedSortFilter.sort
          "
          icon="ri-sort-desc"
          :aria-label="$t('sortDescending')"
          text
          size="small"
          @click="changeSortOrder"
        />
      </slot>
      <slot name="after-sort" />
    </div>
  </div>
</template>
<script>
import Button from "primevue/button";
import Select from "primevue/select";
export default {
  name: "ContentFiltersHeader",
  components: {
    PrimeButton: Button,
    PrimeSelect: Select,
  },
  props: {
    selectedSortFilter: {
      type: Object,
      default: () => ({}),
    },
    isAscending: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["changeSortOrder", "update:selectedSortFilter"],
  data() {
    return {
      filterSortOption: [
        {
          name: this.$t("mostRelevant"),
        },
        {
          name: this.$t("column.name"),
          sort: [{ type: "FIELD", field: "cm:name", ascending: false }],
        },
        {
          name: this.$t("facets.categories.modified_date"),
          sort: [{ type: "FIELD", field: "cm:modified", ascending: false }],
        },
        {
          name: this.$t("column.modifiedBy"),
          sort: [{ type: "FIELD", field: "cm:modifier", ascending: false }],
        },
      ],
    };
  },
  computed: {
    sortableOptions() {
      return this.filterSortOption.filter((opt) => opt.sort);
    },
    defaultSortOption() {
      return this.filterSortOption.find((opt) => !opt.sort);
    },
    selectedSortFilterCopy: {
      get() {
        if (!this.selectedSortFilter?.sort) {
          return null;
        }
        return this.selectedSortFilter;
      },
      set(value) {
        this.$emit(
          "update:selectedSortFilter",
          value ?? this.defaultSortOption,
        );
      },
    },
  },
  methods: {
    changeSortOrder() {
      this.$emit("changeSortOrder");
    },
  },
};
</script>

<style scoped lang="scss">
.filters-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.5rem;
  background: var(
    --p-dataview-header-background,
    var(--p-content-hover-background)
  );
  border-color: var(
    --p-dataview-header-border-color,
    var(--p-content-border-color)
  );
  border-style: solid;
  border-width: 1px 1px 0 1px;
}

.filters-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.option-item {
  display: flex;
  align-items: center;
}
</style>
